export default "__VITE_ASSET__B$tXxMTI__"